import { createReducer, on } from '@ngrx/store';
import { updateMediaForm } from '../Actions/media.actions';
import { MediaState, initialMediaState } from '../State/media.state';
import * as MediaActions from '../Actions/media.actions'

export const mediaReducer = createReducer(
  initialMediaState,
  on(updateMediaForm, (state, payload) => ({
    ...state,
    MediaFormEvent: { ...payload }
  })),
   on(MediaActions.resetMediaState, state => ({
      ...state,
      MediaFormEvent: null
    }))
);
